import * as React from 'react';
const DeskIcon = ({ mainColor }) => (
  <svg
    id="Calque_2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 41.64 43.59"
  >
    <g id="Calque_1-2">
      <rect
        fill={mainColor}
        opacity={0.69}
        x={13.88}
        y={15.83}
        width={27.76}
        height={27.76}
        rx={5.34}
        ry={5.34}
      />
      <rect
        fill={mainColor}
        x={0}
        y={0}
        width={27.76}
        height={27.76}
        rx={13.88}
        ry={13.88}
      />
    </g>
  </svg>
);
export default DeskIcon;
